import { lazy } from 'react'
import { renderWithLazyLoading } from '../../WebAppLoading'

const OnboardingFlows = lazy(() => import('../../../routes/onboardingflows'))

const OnboardingFlowsLazyLoading = renderWithLazyLoading(<OnboardingFlows />)

export default OnboardingFlowsLazyLoading
